import { ChartAreaInteractive } from '@/admin/components/chart-area-interactive';
import { SectionCards } from '@/admin/components/section-cards';
import React from 'react';

export const DashboardPage: React.FC = () => {
  return (
    <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6 overflow-auto flex-1">
      <SectionCards />
      
      <div className="px-4 lg:px-6">
        <ChartAreaInteractive />
      </div>
    </div>
  );
};
